(function() {
  var section = document.querySelector('.countdown-section');
  if (!section) return;

  var countdownDate = new Date(section.querySelector('[data-countdown-date]') 
    ? section.querySelector('[data-countdown-date]').getAttribute('data-countdown-date')
    : section.getAttribute('data-countdown-date')).getTime();

  function updateCountdown() {
    var now = new Date().getTime();
    var timeRemaining = countdownDate - now;

    if (timeRemaining < 0) {
      document.querySelector('.timer-display').textContent = 'The Wait Is Over!';
      clearInterval(intervalId);
      return;
    }

    var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
    var hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    document.getElementById('days').textContent = days < 10 ? '0' + days : days;
    document.getElementById('hours').textContent = hours < 10 ? '0' + hours : hours;
    document.getElementById('minutes').textContent = minutes < 10 ? '0' + minutes : minutes;
    document.getElementById('seconds').textContent = seconds < 10 ? '0' + seconds : seconds;
  }

  updateCountdown();
  var intervalId = setInterval(updateCountdown, 1000);
})();